export default __webpack_public_path__ + "static/media/element_spec_63.bdda89af.webp";